import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { getExpandedItems } from "./fulfillment-group-csv-utils";

export const BinCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> = {
  header: "Bin",
  cell: (row) => {
    return Array.from(
      new Set(
        row.lineItemLocations?.flatMap((l) =>
          l.bins?.map((b) => (b.quantity ? `${b.bin} (${b.quantity})` : b.bin)),
        ) ?? [],
      ),
    )
      .filter((bin): bin is string => typeof bin === "string")
      .sort((a, b) =>
        a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" }),
      )
      .join(", ");
  },
  expandedCsvCell: (row, expansionIndex) => {
    return getExpandedItems(row)?.[expansionIndex]?.bin ?? "";
  },
};
